import script from "./IcLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./IcLoader.vue?vue&type=script&setup=true&lang=js"

import "./IcLoader.vue?vue&type=style&index=0&id=25616542&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25616542"]])

export default __exports__